import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../../../infrastructure/infrastructure.module';
import { Observable } from 'rxjs';
import { api } from '@bayclubs/utils'
import { camps } from '../../models/models.generated';

@Injectable()
export class PaymentApiService {

    constructor(private http: ApiHttpClient) { }

    
    public refund(id: camps.Guid, reason: camps.SetRefundReasonRequest): Observable<api.OperationResult> {
        return this.http.post<api.OperationResultValue<camps.CampPurchaseDetails>>(`payment/${id}/refund`, reason, true);
    }
}
